import { render } from "./NavRail.vue?vue&type=template&id=0334b06f&scoped=true"
import script from "./NavRail.vue?vue&type=script&lang=js"
export * from "./NavRail.vue?vue&type=script&lang=js"

import "./NavRail.vue?vue&type=style&index=0&id=0334b06f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0334b06f"]])

export default __exports__